export const ACTIVITY_MANAGEMENT_LIST = {
  name: '获取活动列表',
  api: '${ACTIVITY}/bcp-apps/api/B/B/activity/page/list',
  method: "post",
  doc: "http://192.168.14.130:8180/doc.html#/%E5%BA%94%E7%94%A8%E5%B8%82%E5%9C%BA/%E6%8F%90%E4%BE%9B%E7%BB%99B%E7%AB%AF%EF%BC%9AB%E7%AB%AF--%E6%B4%BB%E5%8A%A8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/pageListActivityUsingPOST"
};
export const ACTIVITY_MANAGEMENT_DETAIL = {
  name: '获取活动详情',
  api: '${ACTIVITY}/bcp-apps/api/B/B/app/activity/detail'
};

export const LAUNCH_COUPON_LIST = {
  name: '获取活动详情',
  method: 'post',
  api: '${ACTIVITY}/bcp-coupon-dev/api/B/coupon/batch/list',
  doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611823'
};
export const FACECOUPON_LIST = {
  name: '面对面赠券—券批列表',
  api: '${FACE2FACE}/app-face/app/coupon/list',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#56dd9434fd982a153e4e55339456e998',
};
